'use client';
import { useCustomer } from '@hooks/customer';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { productReviewed, recipeReviewed } from '@repo/ui/src/services/analytics';
import React from 'react';

type ProductType = 'product' | 'recipe' | 'apparel';
interface Props {
  sku: string;
  type: ProductType;
}

declare global {
  interface BazaarVoiceCBData {
    Id: string;
    TotalQuestionCount: number;
    TotalAnswerCount: number;
    TotalReviewCount: number;
    TotalContentCount: number;
    BVProduct: 'swat_reviews' | 'swat_questions' | 'inpage_submission';
    ContentType: 'Reviews' | 'Questions' | 'Answers';
    SubmittedStep:
    | 'mandatory'
    | 'photoVideo'
    | 'personalInformation'
    | 'productRating'
    | 'brandDetails';
  }
  type BVCB = (data: BazaarVoiceCBData) => void;
  interface BVConfig {
    events?: {
      submissionSubmitted?: BVCB;
    };
  }
  interface Window {
    BV: {
      globalEvents?: {
        events?: {
          submissionSubmitted?: Array<BVCB>;
        };
      };
      configure: (type: string, config: BVConfig) => void;
    };
  }
}

const Reviews = ({ sku, type }: Props) => {
  const { enableBazaarvoice } = useCurrentUrl();
  const { data: user } = useCustomer();

  React.useEffect(() => {
    if (
      enableBazaarvoice &&
      Object.prototype.hasOwnProperty.call(window, 'BV') &&
      type !== 'apparel'
    ) {

      const isBVTimeout = (err: any) =>
        typeof err.message === 'string' &&
        /script timeout.*bazaarvoice\.com/.test(err.message);

      try {
        const cb = (data: BazaarVoiceCBData) => {
          if (type === 'recipe') {
            recipeReviewed({
              recipe_id: data.Id,
              email: user?.email ?? '',
              review_body: '',
              review_rating: '',
              review_title: ''
            });
          } else {
            productReviewed({
              product_id: data.Id,
              email: user?.email,
            });
          }
        };
        window.BV?.configure?.('global', {
          events: {
            submissionSubmitted: cb,
          },
        });
        return () => {
          if (window.BV?.globalEvents?.events?.submissionSubmitted?.length) {
            window.BV.globalEvents.events.submissionSubmitted = [];
          }
        };
      } catch (error: any) {
        if (isBVTimeout(error)) {
          console.warn('BazaarVoice timeout error:', error);
        } else {
          throw error;
        }
      }
    }
  }, [enableBazaarvoice, type, user?.email]);

  return enableBazaarvoice ? (
    <div className="container active tw-m-10" id="reviews">
      <div className="review">
        <div
          data-bv-show="reviews"
          data-bv-product-id={sku}
          data-bv-seo="false"
        ></div>
      </div>
    </div>
  ) : null;
};

export default Reviews;
